import Link from "next/link";
import React from "react";
import { NextSeo } from "next-seo";

const PrivacyPage = () => {
  return (
    <div className="container">
      <NextSeo
        title="Privacy Policy | Jammable"
        description="Jammable's privacy policy. Learn about how we collect, use, and protect your personal data."
        canonical="https://www.jammable.com/privacy"
      />
      <div className="main">
        <div className="title">Privacy Policy</div>
        Jammable (&quot;us&quot;, &quot;we&quot;, or &quot;our&quot;) operates
        the website (the &quot;Service&quot;). This page informs you of our
        policies regarding the collection, use, and disclosure of personal data
        when you use our Service and the choices you have associated with that
        data. We use your data to provide and improve the Service. By using the
        Service, you agree to the collection and use of information in
        accordance with this policy. Unless otherwise defined in this Privacy
        Policy, terms used in this Privacy Policy have the same meanings as in
        our Terms and Conditions, accessible from https://www.jammable.com/terms
        <div className="subtitle">1. Information Collection and Use</div>
        We collect several different types of information for various purposes
        to provide and improve our Service to you.
        <div className="subtitle">1.1 Personal Data</div>
        While using our Service, we may ask you to provide us with certain
        personally identifiable information that can be used to contact or
        identify you (&quot;Personal Data&quot;). Personally identifiable
        information may include, but is not limited to:
        <ul>
          <li>- Email address</li>
          <li>- First name and last name</li>
          <li>- Cookies and Usage Data</li>
        </ul>
        <div className="subtitle">1.2 Usage Data</div>
        We may also collect information on how the Service is accessed and used
        (&quot;Usage Data&quot;). This Usage Data may include information such
        as your computer&apos;s Internet Protocol address (e.g., IP address),
        browser type, browser version, the pages of our Service that you visit,
        the time and date of your visit, the time spent on those pages, unique
        device identifiers, and other diagnostic data.
        <div className="subtitle">1.3 Tracking & Cookies Data</div>
        We use cookies and similar tracking technologies to track the activity
        on our Service and hold certain information. Cookies are files with a
        small amount of data which may include an anonymous unique identifier.
        Cookies are sent to your browser from a website and stored on your
        device. Tracking technologies also used are beacons, tags, and scripts
        to collect and track information and to improve and analyze our Service.
        You can instruct your browser to refuse all cookies or to indicate when
        a cookie is being sent. However, if you do not accept cookies, you may
        not be able to use some portions of our Service.
        <div className="subtitle">2. Use of Data</div>
        Jammable uses the collected data for various purposes:
        <ul>
          <li>- To provide and maintain our Service</li>
          <li>- To notify you about changes to our Service</li>
          <li>
            - To allow you to participate in interactive features of our Service
            when you choose to do so
          </li>
          <li>- To provide customer support</li>
          <li>
            - To gather analysis or valuable information so that we can improve
            our Service
          </li>
          <li>- To monitor the usage of our Service</li>
          <li>- To detect, prevent and address technical issues</li>
          <li>
            - To provide you with news, special offers, and general information
            about other goods, services, and events which we offer that are
            similar to those that you have already purchased or inquired about
            unless you have opted not to receive such information
          </li>
        </ul>
        <div className="subtitle">3. Disclosure of Data</div>
        We may disclose your Personal Data in the good faith belief that such
        action is necessary to:
        <ul>
          <li>- To comply with a legal obligation</li>
          <li>- To protect and defend the rights or property of Jammable</li>
          <li>
            - To prevent or investigate possible wrongdoing in connection with
            the Service
          </li>
          <li>
            - To protect the personal safety of users of the Service or the
            public
          </li>
          <li>- To protect against legal liability</li>
        </ul>
        <div className="subtitle">4. Security of Data</div>
        The security of your data is important to us, but remember that no
        method of transmission over the Internet, or method of electronic
        storage, is 100% secure. While we strive to use commercially acceptable
        means to protect your Personal Data, we cannot guarantee its absolute
        security.
        <div className="subtitle">5. Service Providers</div>
        We may employ third-party companies and individuals to facilitate our
        Service (&quot;Service Providers&quot;), to provide the Service on our
        behalf, to perform Service-related services, or to assist us in
        analyzing how our Service is used. These third parties have access to
        your Personal Data only to perform these tasks on our behalf and are
        obligated not to disclose or use it for any other purpose.
        <div className="subtitle">5.1 Analytics</div>
        We may use third-party Service Providers to monitor and analyze the use
        of our Service. Google Analytics Google Analytics is a web analytics
        service offered by Google that tracks and reports website traffic.
        Google uses the data collected to track and monitor the use of our
        Service. This data is shared with other Google services. Google may use
        the collected data to contextualize and personalize the ads of its own
        advertising network. You can opt-out of having your activity on the
        Service available to Google Analytics by installing the Google Analytics
        opt-out browser add-on. The add-on prevents the Google Analytics
        JavaScript (ga.js, analytics.js, and dc.js) from sharing information
        with Google Analytics about visits activity. For more information on the
        privacy practices of Google, please visit the Google Privacy & Terms web
        page: http://www.google.com/intl/en/policies/privacy/
        <div className="subtitle">6. Links to Other Sites</div>
        Our Service may contain links to other sites that are not operated by
        us. If you click on a third-party link, you will be directed to that
        third party&apos;s site. We strongly advise you to review the Privacy
        Policy of every site you visit. We have no control over and assume no
        responsibility for the content, privacy policies, or practices of any
        third-party sites or services.
        <div className="subtitle">7. Children&apos;s Privacy</div>
        Our Service does not address anyone under the age of 13
        (&quot;Children&quot;). We do not knowingly collect personally
        identifiable information from anyone under the age of 13. If you are a
        parent or guardian and you are aware that your Child has provided us
        with Personal Data, please contact us. If we become aware that we have
        collected Personal Data from children without verification of parental
        consent, we take steps to remove that information from our servers.
        <div className="subtitle">8. Changes to This Privacy Policy</div>
        We may update our Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page. We will
        let you know via email and/or a prominent notice on our Service, prior
        to the change becoming effective and update the &quot;effective
        date&quot; at the top of this Privacy Policy. You are advised to review
        this Privacy Policy periodically for any changes. Changes to this
        Privacy Policy are effective when they are posted on this page.
        <div className="subtitle">9. Contact Us</div>
        If you have any questions about this Privacy Policy, please contact us:
        <ul>
          <li>- By email: support@jammable.com</li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPage;
